import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetHelpCenterArticleBreacrumbs} from '../hooks/useGetHelpCenterArticle';
import {HelpCenterBreadcrumbs} from '../shared/HelpCenterBreadcrumbs';
import {LoadingPlaceholder} from './LoadingPlaceholder';

export const HelpCenterArticleBreadcrumbs = () => {
  return (
    <DataFetcher
      request={useGetHelpCenterArticleBreacrumbs()}
      View={HelpCenterBreadcrumbs}
      Error={() => null}
      Loading={LoadingPlaceholder}
    />
  );
};
